import { roleId, urls } from '../constants/app';
import request from './utils/request';
import { setError, resetError } from './errors';
import moment from 'moment';
import swal from 'sweetalert';

export function getCurrentUser() {
    return (dispatch, getState) => {
        const user = getState().user.info;
        if (user) {
            dispatch({ type: 'SET_LOADER', field: 'global', value: false });
        } else {
            dispatch({ type: 'SET_LOADER', field: 'global', value: true });
            request({ method: 'get', url: urls.currentUser })
                .then((response) => {
                    dispatch({ type: 'SET_USER_INFO', user: response });
                    dispatch({ type: 'SET_LOADER', field: 'global', value: false });
                })
                .catch(error => {
                    dispatch(setError(error, 'global'));
                    dispatch({ type: 'SET_LOADER', field: 'global', value: false });
                });
        }
    }
}

export function fetchUsers(source) {
    return (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'users', value: true });
    const user = getState().user.info;
    const paging = getState().users.paging;
    const sorting = getState().users.sorting;
    const filters = getState().users.filters;

    const notParams = { 'id_ne': user.id };
    const params = {};

    if (user.role.id === roleId.manager && source !== 'clients') {
        notParams['role.id_in'] = [roleId.cashier, roleId.courier];
    }

    if (user.role.id === roleId.operationDirector && source !== 'clients') {
        notParams['role.id_in'] = [roleId.regionalDirector, roleId.cashier, roleId.commodityExpert, roleId.accountant, roleId.courier, roleId.manager, roleId.accountant, roleId.commodityExpert];
    }

    if (user.role.id === roleId.regionalDirector && source !== 'clients') {
        notParams['role.id_in'] = [roleId.cashier, roleId.commodityExpert, roleId.accountant, roleId.courier, roleId.manager];
    }

    if (filters.city) {
        if (source === 'clients') notParams['city.id'] = filters.city.value;
        if (source === 'users') notParams['points.city.id'] = filters.city.value;
    }

    if (filters.phone) {
        notParams['phone'] = filters.phone;
    }

    if (filters.name) {
        notParams['name_contains'] = filters.name;
    }

    if (filters.username) {
        notParams['username'] = filters.username;
    }

    if (filters.email) {
        notParams['email'] = filters.email;
    }

    if (filters.point) {
        notParams['points.id_in'] = filters.point.value;
    } else if (user.points) {
        notParams['points.id_in'] = user.points.map((el) => el.id);
    }

    if (filters.createdStartDate) {
        notParams['created_at_gte'] = moment(filters.createdStartDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        params['created_at_gte'] = moment(filters.createdStartDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
    }

    if (filters.createdEndDate) {
        notParams['created_at_lte'] = moment(filters.createdEndDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
        params['created_at_lte'] = moment(filters.createdEndDate).subtract({hours:3}).format('YYYY-MM-DD HH:mm:ss');
    }
    
    if(source === 'clients') {
        notParams['role.id'] = roleId.client;
    }

    if(source === 'users') {
        notParams['role.id_nin'] = [roleId.client , roleId.admin];
    }

    params['_start'] = paging.start;
    params['_limit'] = paging.limit;

    params['_sort'] = `${sorting.field}:${sorting.type}`;

    request({ method: 'get', url: urls.counter+'/users', params: notParams })
        .then((response) => {
            dispatch({ type: 'SET_USERS_COUNT', count: response ? response : 0 });
            return;
        })
        .then(() => {
            return request({ method: 'get', url: urls.users, params: { ...params, ...notParams } }).then(res => {
                dispatch({ type: 'SET_USERS', users: res });
                dispatch({ type: 'SET_LOADER', field: 'users', value: false });
            });
        })
        .catch(error => {
            dispatch(setError(error, 'users'));
            dispatch({ type: 'SET_LOADER', field: 'users', value: false });
        });
    }
}

export function fetchUsersByRole(filters, dataParams = {}) {
    return async () => {
        const params = dataParams;

        if (filters.city) params['points.city.id'] = filters.city;
        if (filters.role) params['role.id'] = filters.role;
        if (filters.points) params['points.id_in'] = filters.points;

        try {
            const result = await request({ method: 'get', url: urls.users, params });
            return result;
        } catch (error) {
            return error;
        }
    }
}

export function setUsersPaging(paging) {
    return dispatch => {
        dispatch({ type: 'SET_USERS_PAGING', paging });
    }
}

export function setUsersFilters(filters) {
    return dispatch => {
        dispatch({ type: 'SET_USERS_FILTERS', filters });
    }
}

export function fetchUser(id) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'user', value: true });

    return request({ method: 'get', url: `${urls.users}/${id}` })
        .then((response) => {
            dispatch({ type: 'SET_USER', user: response });
            dispatch({ type: 'SET_LOADER', field: 'user', value: false });
            return response;
        })
        .catch(error => {
            dispatch(setError(error, 'user'));
            dispatch({ type: 'SET_LOADER', field: 'user', value: false });
            return null
        });
    }
}

export function updateUser(id, params) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'updateUser', value: true });
    dispatch(resetError('user'));
    return request({ method: 'put', url: `${urls.users}/${id}`, data: params })
        .then((response) => {
            dispatch({ type: 'SET_USER', user: response });
            dispatch({ type: 'SET_LOADER', field: 'updateUser', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'user'));
            dispatch({ type: 'SET_LOADER', field: 'updateUser', value: false });
            return false;
        });
    }
}

export function restoreUser(id, source) {
    return (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'users', value: true });
    dispatch(resetError('users'));
    const params = { restore: true };
    const user = getState().user.info;
    params.author = user ? user.name ? user.name : user.username : null;
    request({ method: 'delete', url: `${urls.users}/${id}`, params })
        .then((response) => {
            dispatch(fetchUsers(source));
            dispatch({ type: 'SET_LOADER', field: 'users', value: false });
        })
        .catch(error => {
            dispatch(setError({ status: 507 }, 'users'));
            dispatch({ type: 'SET_LOADER', field: 'users', value: false });
        });
    }
}

export function deleteUser(id, source, fullDelete, restore) {
    return (dispatch, getState) => {
    dispatch({ type: 'SET_LOADER', field: 'users', value: true });
    dispatch(resetError('users'));
    const params = {};
    if (!fullDelete) {
        const user = getState().user.info;
        params.author = user ? user.name ? user.name : user.username : null;
        if (restore) params.restore = true;
    } else {
        params.fullDelete = true;
    }
    request({ method: 'delete', url: `${urls.users}/${id}`, params })
        .then((response) => {
            dispatch(fetchUsers(source));
            dispatch({ type: 'SET_LOADER', field: 'users', value: false });
        })
        .catch(error => {
            dispatch(setError({ status: 507 }, 'users'));
            dispatch({ type: 'SET_LOADER', field: 'users', value: false });
        });
    }
}

export function registerUser(user) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'register', value: true });
    dispatch(resetError('register'));
    return request({ method: 'post', url: urls.users, data: user })
        .then((response) => {
            dispatch({ type: 'SET_LOADER', field: 'register', value: false });
            return true;
        })
        .catch(error => {
            dispatch(setError({ status: 506 }, 'register'));
            dispatch({ type: 'SET_LOADER', field: 'register', value: false });
            return false;
        });
    }
}

export function setAddForm(data) {
    return (dispatch) => {
        dispatch({ type: 'SET_ADD', data });
    }
}

export function sendCashBack(cashback, userID, order, operationType) {
    return request({ method: 'post', url: `${urls.cashback}/send`, data: { cashback, userID, order, operationType } })
        .then((response) => {
            return true;
        })
        .catch(error => {
            return false;
        });
}

export function fetchCashiersDevice(point) {
    return (dispatch) => {
    dispatch({ type: 'SET_LOADER', field: 'device', value: true });
    const params = {};

    params['role.id_in'] = [roleId.manager, roleId.cashier, roleId.regionalDirector];
    params['points.id_in'] = point;
    params['inn_null'] = false;

    return request({ method: 'get', url: urls.users, params }).then(res => {
        dispatch({ type: 'SET_LOADER', field: 'device', value: false });
        return res;
    })
    .catch(error => {
        dispatch({ type: 'SET_LOADER', field: 'device', value: false });
        return {error: error}
    });;
    }
}

export function fetchCouriers(orders, role) {
    return (dispatch) => {
        dispatch({ type: 'SET_LOADER', field: 'couriers', value: true });
        if (role === roleId.courier) {
            dispatch({ type: 'SET_LOADER', field: 'couriers', value: false });
            return null;
        }

        const items = orders.map((item) => {
            if (item.point && item.point.id) return item;
            if (item.zone && item.zone.point && item.zone.point.id) item.point = item.zone.point;
            return item;
        })

        const points = items
        .filter(order => order.point && order.point.id)
        .reduce((acc, order) => {
            const pointId = order.point.id;
            if (!acc.includes(pointId)) {
              acc.push(pointId);
            }
            return acc;
          }, []);
        
        try {
            if (!points || points.length === 0) return null;
            const params = {};
            params['points.id_in'] = points;
            params['role.id'] = roleId.courier;
            return request({ method: 'get', url: urls.users, params })
            .then((response) => {
                return response;
            });
        } catch (err) {
            return (
                swal({
                    title: "Ошибка поиска курьеров",
                    text: err ? err : '',
                    icon: "error",
                    dangerMode: true,
                    button: "Ок",
                })
            )
        } finally {
            dispatch({ type: 'SET_LOADER', field: 'couriers', value: false });
        }
    }
}